export default {
  gameSummary: {
    sections: {
      matchupInformation: "Information sur le matchup",
      rankings: "Classements",
    },
    labels: {
      record: "Fiche",
      rank: "Classement",
      type: "Type",
      stat: "Stat",
      filterByGame: "Filtrer par match",
      position: "Position",
      injury: "Blessure",
      status: "Statut",
      trend: "Tendance",
    },
    standingTypes: {
      division: "Division",
      conference: "Conférence",
      league: "Ligue",
      overall: "Général",
    },
    rankingSides: {
      FOR: "POUR",
      AGAINST: "CONTRE",
    },
    statAbbreviations: {
      PTS: "PTS",
      "SCORE %": "% MARQ.",
      "SCORE%": "% MARQ.",
      PLAYS: "JEUX",
      "NET YDS": "YDS NETS",
      "PASS YDS": "YDS PASSE",
      "PASS ATT": "TENT. PASSE",
      "PASS COMPL": "PASSES COMP.",
      "PASS TD": "TD PASSE",
      "RUSH YDS": "YDS COURSE",
      "RUSH ATT": "TENT. COURSE",
      "RUSH TD": "TD COURSE",
      "TOTAL TDS": "TD TOTAL",
      "RZ%": "% ZR",
      "1D": "1D",
      "3D%": "% 3D",
      "4D%": "% 4D",
      INT: "INT",
      TO: "PERTES",
      SACKS: "SACKS",
      FUML: "ÉCH.",
      G: "B",
      SOG: "TAC",
      SAT: "TENT. TIR",
      "CF%": "% CF",
      "PP%": "% AN",
      PIM: "MIN PÉN.",
      PPG: "B AN",
      SHG: "B DN",
      "SH%": "% TIR",
      BLK: "BLQ",
      FTM: "LF RÉU.",
      FTA: "LF TENT.",
      "FT%": "% LF",
      FGM: "T RÉU.",
      FGA: "T TENT.",
      "FG%": "% T",
      "3PTM": "3P RÉU.",
      "3PTA": "3P TENT.",
      "3PT%": "% 3P",
      "TS%": "% TS",
      "eFG%": "% eFG",
      TRB: "REB",
      AST: "AST",
      STL: "INT",
      R: "P",
      H: "H",
      "1B": "1B",
      "2B": "2B",
      "3B": "3B",
      TB: "BT",
      ER: "PM",
      HR: "HR",
      RBI: "PP",
      BB: "BB",
      SO: "SO",
      E: "E",
      AVG: "AVG",
      OBP: "OBP",
      SLG: "SLG",
      OPS: "OPS",
      POS: "POS",
      SHO: "TIRS",
      SOT: "TAC",
      COR: "COR",
      OFF: "HJ",
      FLS: "FAUTES",
      "2YELRED": "2J+R",
      YEL: "JAUNE",
      RED: "ROUGE",
      T: "T",
      "CR%": "% COMP.",
      RM: "M COURSE",
      LB: "BRIS",
      K: "BOT.",
      KM: "M BOT.",
    },
    quickPicks: {
      moneyline: "Moneyline",
      spread: "Écart",
      total: "Total",
    },
  },
};
